import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@quantum-ecosystem/ui-toolkit';
import FormField from '../FormField';

const spacing = { xs: 8, sm: 12, md: 16, lg: 24, xl: 32 };
const withSpacing = (value) => typeof value === 'string' ? `${spacing[value] ?? value}px` : typeof value === 'number' ? `${value}px` : value;

const FormInput = forwardRef(({ 
	label,
	withAsterisk,
	description,
	hint,
	error,
	leftSection,
	rightSection,
	leftSectionWidth,
	rightSectionWidth,
	size,
	mt,
	mb,
	w,
	style,
	wrapperClassName,
	...props
}, ref) => (
	<Input
		ref={ref}
		size={['xs', 'sm'].includes(size) ? 'sm' : ['lg', 'xl'].includes(size) ? 'lg' : size}
		label={label && withAsterisk ? <>{label}<span className="q-form-required"> *</span></> : label}
		hint={hint ?? description}
		error={error || undefined}
		leftIcon={leftSection}
		rightIcon={rightSection}
		wrapperClassName={wrapperClassName}
		style={{ marginTop: withSpacing(mt), marginBottom: withSpacing(mb), width: withSpacing(w), ...style }}
		{...props}
	/>
));

FormInput.displayName = 'FormInput';

const FormInputDescription = ({ children, mt, className = '', ...props }) => (
	<div className={`q-form-hint ${className}`.trim()} style={{ marginTop: withSpacing(mt) }} {...props}>{children}</div>
);
const FormInputError = ({ children, mt, className = '', ...props }) => (
	<div className={`q-form-error ${className}`.trim()} style={{ marginTop: withSpacing(mt) }} {...props}>{children}</div>
);
const FormInputLabel = ({ children, required, m, p, className = '', style, ...props }) => (
	<label className={`q-form-label ${className}`.trim()} style={{ margin: withSpacing(m), padding: withSpacing(p), ...style }} {...props}>{children}{required && <span className="q-form-required"> *</span>}</label>
);
FormInput.Wrapper = FormField;
FormInput.Description = FormInputDescription;
FormInput.Error = FormInputError;
FormInput.Label = FormInputLabel;
FormInputDescription.propTypes = { children: PropTypes.node, mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), className: PropTypes.string };
FormInputError.propTypes = { children: PropTypes.node, mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), className: PropTypes.string };
FormInputLabel.propTypes = { children: PropTypes.node, required: PropTypes.bool, m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), p: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), className: PropTypes.string, style: PropTypes.object };

FormInput.propTypes = {
	label: PropTypes.node,
	withAsterisk: PropTypes.bool,
	description: PropTypes.node,
	hint: PropTypes.node,
	error: PropTypes.node,
	leftSection: PropTypes.node,
	rightSection: PropTypes.node,
	mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	style: PropTypes.object,
	wrapperClassName: PropTypes.string,
	size: PropTypes.string,
};

export default FormInput;
